export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '热门排行', href: '#ranking' },
        { label: '最新动态', href: '#updates' },
        { label: '移动端下载', href: '#app' },
        { label: '联系我们', href: '#contact' },
      ],
    },
    {
      title: '内容分类',
      links: [
        { label: '主题索引', href: '#index' },
        { label: '话题标签', href: '#topics' },
        { label: '精选推荐', href: '#carousel' },
        { label: '常见问题', href: '#faq' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '特色优势', href: '#features' },
        { label: '用户评价', href: '#comments' },
        { label: '媒体展示', href: '#media' },
      ],
    },
  ];

  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">
                91免费视频
              </span>
            </a>
            <p className="text-sm text-background-300 leading-relaxed">
              91免费视频网站致力于为广大用户提供海量高清在线视频资源，涵盖91免费视频网站在线观看、91在线观看视频网站等多元内容，打造优质的免费视频网站在线观看体验。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-sm text-background-200 mb-4 whitespace-nowrap">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-6">
            <p className="text-xs text-background-400">
              &copy; {currentYear} 91免费视频网站 版权所有
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500">合作伙伴</span>
            </div>
          </div>
          <p className="text-xs text-background-500 text-center leading-relaxed max-w-2xl mx-auto">
            本站为免费视频资源聚合平台，所有内容均来自互联网公开资源。高清视频网站免费观看，在线视频网站免费体验，91免费视频网站在线观看尽在91免费视频网站。
          </p>
        </div>
      </div>
    </footer>
  );
}